import React from 'react';
import Card from 'react-bootstrap/Card';
import { Carousel, CarouselCaption, CarouselItem } from 'react-bootstrap';


function CarouselTableauDeBord() {
  return (
    <>
        <Carousel  style={{width:"99%"}}>
            <CarouselItem>
            <Card.Img variant="top" src="/img/arbitreTB.jpg" style={{height:"auto", maxHeight:"680px"}} />
            <CarouselCaption>
            <h3>Les Arbitres : Gardiens de l'intégrité du Jeu</h3>
            <p>Les arbitres, ces figures emblématiques qui sillonnent les terrains de sport, sont bien plus que de simples arbitres de règles. Ils incarnent l'essence même de l'intégrité du jeu et la garantie d'une compétition équitable.</p>
            </CarouselCaption>
            </CarouselItem>
            <CarouselItem >
            <Card.Img variant="top" src="/img/arbitreTB2.jpg" style={{height:"auto", maxHeight:"680px"}} />
            <CarouselCaption>
                <h3>Le Respect entre équipes</h3>
                <p>Dans l'arène compétitive du sport, le respect entre équipes est un pilier fondamental qui transcende les résultats et les performances.</p>
            </CarouselCaption>
            </CarouselItem>
        </Carousel>
  

    </>
  );
}

export default CarouselTableauDeBord;